import React, { useContext, useEffect, useState } from "react";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import HeaderTable from "../../../components/generic/HeaderTable";
import HeaderGeneric from "../../../components/generic/headerGeneric";
import {
  CommandBar,
  FontIcon,
  IColumn,
  ICommandBarItemProps,
  Icon,
  SearchBox,
  SelectionMode,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import IconHelper from "../../../utils/helpers/iconHelper";
import { HeaderGestionDocumentos } from "../general/HeaderGestionDocumentos";
import { IDataTablePersonas } from "../../../Interfaces/IPersona";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import { ConfigHelper } from "../../../utils/helpers/configHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { TableV8 } from "../../../components/Table/TablaV8";
import { PaginationV8 } from "../../../components/PaginationFooter/PaginationV8";
import { useVistaTiposDocumentos } from "../hooks/useVistaTiposDocumentos";
import { useGruposDocumentos } from "../hooks/useGruposDocumentos";
import { ITablaGruposDocumentos } from "../../../Interfaces/gestionDocumentos/IGrupoDocumento";
import { PanelRegistrarGrupo } from "./PanelRegistrarGrupo";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelEliminarGrupo } from "./PanelEliminarGrupo";
import { PanelEditarSubGrupo } from "../documentos/PanelEditarSubgrupo";
import { AuthContext } from "../../../auth/context/auth-context";
import { Authorize } from "../../../utils/helpers/authorize";
import { ROLE_ADMIN, R_GESTION_DOC } from "../../../utils/helpers/roleHelpers";

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "20px",
    maxWidth: "20px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
});

export const VistaGruposDocumentos = () => {
  const navigate = useNavigate();

  const { access } = useContext(AuthContext);

  const userRoles = access?.role || [];

  let esEscrituraDoc = Authorize(userRoles, [
    R_GESTION_DOC,
    ROLE_ADMIN,
  ]);

  const {
    loading,
    items,
    filter,
    setFilter,
    limpiarFiltro,
    postListaTabla,
    paginacionTable,
    onChangeTextSearch,
  } = useGruposDocumentos();

  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [
    isOpenEditarSubgrupo,
    { setTrue: openPanelEditarSubGrupo, setFalse: dismissPanelEditarSubgrupo },
  ] = useBoolean(false);

  const [
    isOpenEliminar,
    { setTrue: openPanelEliminar, setFalse: dismissPanelEliminar },
  ] = useBoolean(false);

  const [grupoId, setgrupoId] = useState("");

  const [nombre, setnombre] = useState("");

  const _itemBack: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BACK2,
      onClick: () => {
        // let u = ConfigHelper.urlBase() + "/gestionDocumentos/tipos";
        // navigate(u);
        window.history.back();
      },
    },
  ];

  const _itemsLeftBar: ICommandBarItemProps[] = [

    // {
    //   ...IconHelper.ICON_ADD_TABLE,
    //   text: "Agregar Grupo",
    //   onClick: () => openPanel(),
    // },
    ...(esEscrituraDoc ? [{
      ...IconHelper.ICON_ADD_TABLE,
      text: "Agregar Grupo",
      onClick: () => openPanel(),
    }] : []),
    {
      ...IconHelper.ICON_RELOAD2,
      onClick: () => limpiarFiltro(),
    },
  ];

  useEffect(() => {
    let arrayString = localStorage.getItem("miArray");
    if (arrayString) {
      localStorage.removeItem("miArray");
    }
  }, []);

  const _itemRigthBar: ICommandBarItemProps[] = [
    {
      key: "Search",
      onRender: (item) => {
        return (
          <div>
            <SearchBox
              // underlined
              // componentRef={undefined}
              placeholder={"Buscar"}
              onChange={onChangeTextSearch}
              value={filter.search}
              styles={{
                root: {
                  borderColor: "#bababa",
                  width: "300px",
                  height: "28px",
                  fontSize: 12,
                  borderRadius: "2px",
                },
              }}
            //   underlined={true}

            // defaultValue={props.value === null ? "" : props.value}
            // onSearch={searchHandler}
            // onChange={searchChange}
            // value={props.searchValue == null ? "" : props.searchValue}
            // autoComplete="off"
            // onClear={onClearHandler}
            />
          </div>
        );
      },
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      //   isSorted: true,
      //   isSortedDescending: true,
      onRender: (item: ITablaGruposDocumentos) => (
        <>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "5px" }}
          >
            {/* <FontIcon
              aria-label="Compass"
              iconName="FolderList"
              style={{ fontSize: 15 }}
              // className={undefined}
            /> */}

            <img
              src={
                "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/item-types/16/folder.svg"
              }
              className={classNames.fileIconImg}
              alt={` folder icon`}
            />
            {item.nombre}
          </div>
        </>
      ),
    },
    {
      key: "size",
      name: "Tamaño de archivo",
      fieldName: "size",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha de Creación",
      fieldName: "fecha",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "usuario",
      name: "Registrado Por",
      fieldName: "usuario",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item: ITablaGruposDocumentos) => (
        <>
          <div style={{ display: "flex", columnGap: "5px" }}>
            {esEscrituraDoc && (<>
              <TooltipHost content="Actualizar">
                <Icon
                  iconName="edit"
                  style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    setgrupoId(item.archivoId);
                    setnombre(item.nombre);
                    openPanelEditarSubGrupo();
                  }}
                />
              </TooltipHost>
              <TooltipHost content="Eliminar">
                <Icon
                  iconName="delete"
                  style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    setgrupoId(item.archivoId);
                    openPanelEliminar();
                  }}
                />
              </TooltipHost>
            </>)}

            <TooltipHost content="Gestión de Documentos">
              <Icon
                iconName="FolderSearch"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => {
                  navigate(
                    `${ConfigHelper.urlBase()}/gestionDocumentos/documentos
                        `,
                    {
                      state: { archivoId: item.archivoId, grupo: item.nombre },
                    }
                  );
                }}
              />
            </TooltipHost>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        {/* <pre>{JSON.stringify("--------Exist Data userRoles---", null, 2)}</pre>
        <pre>{JSON.stringify(userRoles, null, 2)}</pre>
        <pre>{JSON.stringify(esEscrituraDoc, null, 2)}</pre> */}

        <HeaderGestionDocumentos
          items={_itemBack}
          title="Gestión de Grupos"
          key={"Gestión de Grupos"}
        />
        {/* <pre>{JSON.stringify(filter, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(paginacionTable, null, 2)}</pre> */}
        <div>
          <TableV8
            key="tv8G"
            leftBar={_itemsLeftBar}
            rigthBar={_itemRigthBar}
            data={items}
            column={_columns}
            isLoading={loading}
            selectionMode={SelectionMode.none}
            footerPagination={
              <PaginationV8
                onChangeTake={paginacionTable.onChangeTake}
                onChangeSkip={paginacionTable.onChangeSkip}
                totalPagesPagination={
                  (paginacionTable.totalPagesPagination ==null
                    ? paginacionTable.totalPagesPagination
                    : 1)
                }
                skipPagination={paginacionTable.skipPagination}
                takePagination={paginacionTable.takePagination}
                isLoading={loading}
                cantidad={items?.length}
                total={
                  paginacionTable.total != null ? paginacionTable.total : 0
                }
              />
            }
          />
        </div>
      </div>

      <PanelRegistrarGrupo
        key="PRD"
        isOpen={isOpen}
        onDismiss={dismissPanel}
        onRenderTable={limpiarFiltro}
      />

      <PanelEditarSubGrupo
        key="PES"
        isOpen={isOpenEditarSubgrupo}
        onDismiss={dismissPanelEditarSubgrupo}
        onRenderTable={limpiarFiltro}
        archivoId={grupoId}
        nombre={nombre}
        tipo="01"
      />

      <PanelEliminarGrupo
        key="PEG"
        isOpen={isOpenEliminar}
        onDismiss={dismissPanelEliminar}
        onRenderTable={limpiarFiltro}
        archivoId={grupoId}
      />
    </>
  );
};
